import React, { Component } from "react";
import { Row, Col } from 'react-bootstrap';
import Table from "react-bootstrap/Table";
import { OrderRequestFiles } from "../../request-details-files.component";
import { RequestOnBehalfDetails } from "../../request-on-behalf-details.component";
import Translation from "../../../../../common/translation/translation.component";
import { ORDER_STATUS, CIRCUIT_STATUS } from "../../../../../../constants/external-constants";
import { YES_OR_NO } from '../../../../../../utils/constant.utils';
import Icons from '../../../../../icon';
import { convertToDecimal } from "../../../../../../utils/helpers.utils";

export class ReplaceDeviceDetails extends Component {
    constructor(props) {
        super(props);
    }

    handleShow = () => {
        this.setState({
            show: true
        });
    }

    displayAccessories = (accessories, currency) => {

        return accessories != null && accessories.length != 0
            ? accessories.map((item, i) => (

                <tr key={i}>
                    <td>{i == 0 ? <Translation translationKey="accessory" /> : null}</td>
                    <td>
                        <Row>
                            <Col xs={6} md={6} lg={6} className="request-details-sec-val">
                                {item.EquipmentModel}
                            </Col>
                            <Col xs={6} md={6} lg={6} className="request-details-sec-val">
                                {currency} {item.OrderCost.toFixed(2)}
                            </Col>
                        </Row>
                    </td>
                </tr>
            ))
            : null;
    }

    editRequest = (orderStatusId, endUserId, requestorId) => {
        const editableRequest = (orderStatusId === ORDER_STATUS.waitingForAuthorization || orderStatusId === ORDER_STATUS.open);

        var employeeId = sessionStorage.getItem('EmployeeID');
        const isRequestOwner = (endUserId == employeeId) || (requestorId == employeeId);
        const showUpdateRequestLink = this.props.history.location.pathname.match(/Inventory.*/) === null ? true : false;

        return editableRequest && isRequestOwner && showUpdateRequestLink;
    }


    render() {
        const { data, isWireline, openRequestModal } = this.props;
        const {Order: { RequestType: { RequestTypeID, RequestType }, OrderStatusId, EndUserId, RequestorId }} = data || {};
        return (
            <div>                
                <h4 className="order-detail-title"><Translation translationKey="order_request_details" />
                {this.editRequest(OrderStatusId, EndUserId, RequestorId) ?  
                        <Icons
                        customClassName="pen-to-square"
                        name="pen-to-square"
                        size="20px"
                        containerClass="icon-circle-plus-container"
                        onClick={() =>{openRequestModal(RequestTypeID, RequestType)}} 
                        labelValue={"Update Order Request"}
                        labelClass="order-detail-edit-label"                                                              
                        />

                        : null 
                    }
                </h4>            
                <div className="order-detail-location">
                    <div className="order-detail-number-container">
                        <div className="order-title">
                            <Translation translationKey="order_number" />
                        </div>
                        <div className="order-label">
                            {data.Order.OrderNumber}
                        </div>
                    </div>                  
                    <div className="order-detail-number-container">
                        <div className="order-title">
                            <Translation translationKey="capital_sr_number" />
                        </div>
                        <div className="sr-number-label">
                            {data.Order.ServiceRequestNumber}
                        </div>
                    </div>                  
                    {data.Order.IsRequestedInBehalf ?
                        <RequestOnBehalfDetails robDetails={data.RequestedInBeHalfOf} isRob={data.Order.IsRequestedInBehalf} />
                        : null}
                    <h5 className="order-detail-location-title"><Translation translationKey="subscription_upper" /></h5> 
                    <Table>
                        <tbody>
                            <tr>
                                <td className="mobile-number-label"><Translation translationKey="mobile_phone_number" /></td>
                                <td className="mobile-number-label">{data.Circuit.CircuitCode}</td>
                            </tr>
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className={data.Subscription.CircuitStatus == CIRCUIT_STATUS.inService.name ? "status-inservice" : data.Subscription.CircuitStatus == CIRCUIT_STATUS.suspended.name ? "status-suspended" : ""} >{data.Subscription.CircuitStatus}</td>
                            </tr>
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className="mobile-number-label">{data.Subscription.VendorName}</td>
                            </tr>
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className="mobile-number-label">{data.Subscription.PlanDetails.PlanName ?
                                    data.Subscription.PlanDetails.PlanName :
                                    <Translation translationKey="no_plan_available" />}</td>
                            </tr>
                          
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className="mobile-number-label">{data.Subscription && data.Subscription.SubscriptionDetailDevice ?
                                    data.Subscription.SubscriptionDetailDevice.EquipmentModel :
                                    <Translation translationKey="no_device_available" />} </td>
                            </tr>
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title"><Translation translationKey="replace_upgrade" /></h5>
                    <Table>
                        <tbody>

                            {data.Subscription.MobileServiceModel
                                && data.Subscription.MobileServiceModel.length > 0 ?
                                <tr>
                                    <td><Translation translationKey="mobile_service_type" /></td>
                                    <td>
                                        <Row>
                                            <Col xs={7} md={7} lg={7}>
                                                {data.Subscription.MobileServiceModel[0].EquipmentModel}
                                            </Col>
                                            <Col xs={5} md={5} lg={5}>
                                                {data.Subscription.DiscountedOrderCost !== null ? convertToDecimal(data.Subscription.DiscountedOrderCost) : convertToDecimal(data.Subscription.OrderCost)}&nbsp;
                                                {data.Subscription.PlanDetails.Currency.CurrencyName}
                                            </Col>
                                        </Row>
                                    </td>
                                </tr> : null
                            }
                            <tr>
                                <td><Translation translationKey="accessory" /></td>
                                <td>{data.Subscription.PhoneCaseAccessory ? YES_OR_NO.Yes : YES_OR_NO.No}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="delivery_address" /></td>
                                {data.BillingAddress.LocationId > 0 ? <td>{data.BillingAddress.DeliveryAddress}</td> : null}
                                {data.OtherLocationID > 0 ? <td>{data.OtherLocationName}</td> : null}
                            </tr>
                            <tr>
                                <td><Translation translationKey="additional_information" /></td>
                                <td>{data.BusinessJustification.AdditionalInformation}</td>
                            </tr>
                            {data.Subscription.MobileServiceModel
                                && data.Subscription.MobileServiceModel.length > 0 &&
                                <tr>
                                    <td><Translation translationKey="total_order_cost" /></td>
                                    <td>{data.Subscription.DiscountedOrderCost !== null ? convertToDecimal(data.Subscription.DiscountedOrderCost) : convertToDecimal(data.Subscription.OrderCost)} {data.Subscription.PlanDetails.Currency.CurrencyName}</td>
                                </tr>
                            }                            
                        </tbody>
                    </Table>
                    {isWireline &&
                        <OrderRequestFiles files={data.Order.OrderFileNames} />
                    }
                </div>
            </div>
        );
    }
}